import styled from 'styled-components'

import Modal from 'components/Modal'

export const TokenDetailsRow = styled.div`
  display: flex;
`

export const TokenDetailsModalBody = styled(Modal.Body)`
  font-size: ${({ theme }) => theme.fontSizes.E};
  padding-bottom: 24px;
`

export const PermissionsHeading = styled.p`
  padding: 0;
  margin-bottom: 8px;
  font-size: ${({ theme }) => theme.fontSizes.C};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`
